<template>
  <router-view v-if="step >= totalSteps" />

  <!-- UI for showing loading -->
  <InitialLoader
    :step="step"
    :total-steps="totalSteps"
  />

  <!-- Loading Steps -->
  <CheckNetwork
    @ready="nextStep(2)"
  />
  <AppVersion
    v-if="step > 1"
    @ready="nextStep(3)"
  />
  <SystemVariables
    v-if="step > 2"
    @ready="nextStep(4)"
  />
  <UserVariables
    v-if="step > 3 && isLoggedIn && $route.name !== 'SandboxIndex' && !$route.path.includes('logout')"
    @ready="nextStep(5)"
    @revert="prevStep(4)"
  />

  <!-- Misc background tasks -->
  <Maintenance />
  <ListenGlobal />
  <DataTracking />
</template>

<script>
/*
 * Root component
 */
import Maintenance from 'components/partials/system/Maintenance'
import AppVersion from 'components/partials/system/AppVersion'
import CheckNetwork from 'components/partials/system/CheckNetwork'
import SystemVariables from 'components/partials/system/SystemVariables'
import UserVariables from 'components/partials/system/UserVariables'
import InitialLoader from 'components/partials/system/InitialLoader'
import DataTracking from 'components/partials/system/DataTracking'

import ListenGlobal from './notifications/ListenGlobal'
import intercomMixin from 'src/helpers/intercom'

import { createMetaMixin } from 'quasar'

export default {
  name: 'App',
  components: {
    InitialLoader, Maintenance, AppVersion, CheckNetwork, SystemVariables, UserVariables, ListenGlobal, DataTracking
  },
  mixins: [
    intercomMixin,
    createMetaMixin(function () {
      return {
        title: this.$route.meta.title,
        titleTemplate: title => `${title} | ${this.siteName}`,
        meta: {
          title: {
            name: 'title',
            content: this.siteName
          },
          description: {
            name: 'description',
            content: this.siteName + ' - save time and grow your business. Generate reports, schedule appointments, keep track of your clients and manage your financials.'
          },
          keywords: {
            name: 'keywords',
            content: 'mira,pestregister,pest register,termite register,termiteregister,pest control software,pest control,crm,best pest control software'
          },
          author: {
            name: 'author',
            content: this.siteName
          }
        }
      }
    })
  ],
  data () {
    return {
      step: 1
    }
  },
  computed: {
    totalSteps () {
      if (this.isLoggedIn && this.$route.name !== 'SandboxIndex' && !this.$route.path.includes('logout')) {
        return 5
      }
      return 4
    }
  },
  methods: {
    prevStep (step) {
      this.step = step
    },
    nextStep (step) {
      if (this.step > step) {
        return
      }
      this.step = step
    }
  },
  mounted () {
    // To bypass maintenance mode, we can check manually for an "mkey" parameter in the URL.
    // The mkey must match the specified maintenance key in the backend in order for
    // the override to work.
    // We cannot use $route at this point because the router is not yet loaded.
    const queryKeys = new URLSearchParams(window.location.search)
    if (queryKeys.has('mkey')) {
      this.$store.commit('setSetting', {
        key: 'mkey',
        value: queryKeys.get('mkey')
      })
    }
  }
}
</script>
